
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import type { LiveClasshourInfo } from '@xt/client/entities/my-v2/types'
import moment from 'moment'
import { formatYearMonthDay } from '@xt/client/utils/my'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class LiveClasshourCard extends Vue {
  @Prop() dataSource: LiveClasshourInfo

  downtimeTimer: NodeJS.Timeout | null = null
  live: boolean = false
  downtimeText: string = ''
  currentTime: number = this.$ajax.serviceDate().utcOffset(+8).valueOf()

  get isToday() {
    return moment(this.dataSource.startTime).isSame(this.currentTime, 'day')
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  showDownTime() {
    if (!this.isToday || this.dataSource.publishStatus !== 1) return false

    if (this.currentTime && this.currentTime < this.dataSource.startTime) {
      this.downtime()
      return true
    }

    if (!this.dataSource.liveEnd) {
      this.live = true
    }

    return false
  }

  downtime() {
    if (this.downtimeTimer) {
      clearInterval(this.downtimeTimer)
      this.downtimeTimer = null
    }
    const curr = this.$ajax.serviceDate().utcOffset(+8).valueOf()
    if (this.dataSource.startTime > curr) {
      this.downtimeText = moment(this.dataSource.startTime - curr)
        .utcOffset(0)
        .format('HH时mm分ss秒')
    } else {
      this.live = true
      return
    }

    this.downtimeTimer = setInterval(() => {
      const curr = this.$ajax.serviceDate().utcOffset(+8).valueOf()
      const diff = this.dataSource.startTime - curr
      if (diff < 0) {
        this.downtimeTimer && clearInterval(this.downtimeTimer)
        this.downtimeTimer = null
        this.live = true
        return
      }
      this.downtimeText = moment(diff).utcOffset(0).format('HH时mm分ss秒')
    }, 500)
  }

  goCourseOrLive() {
    if (this.live || this.downtimeText) {
      // 用户需要完善个人信息
      if (this.UserStore.onneedCompleteInfo()) {
        this.UserStore.onToggleModal(this.$EnumLocaleLinks.links_complete)
        return
      }

      if (!this.dataSource.id) return

      window.open(`/live?classhour=${this.dataSource.id}`, '_blank')
    } else {
      this.$router.push({
        name: 'course-id',
        params: { id: this.dataSource.courseId.toString() }
      })
    }
  }

  created(): void {
    this.showDownTime()
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
